module.exports = __webpack_public_path__ + "img/card5.8df2d8a5.png";